import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

export interface PaymentStatus {
  consultationId: string
  pendingPayment: boolean
  paymentIntentId?: string
  status?: string
  amount?: number
  currency?: string
  publicKey: string
}

export interface PaymentIntentResponse {
  clientSecret: string
  paymentIntentId: string
  amount: number
  currency: string
  publicKey: string
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private http = inject(HttpClient)
  private base = environment.apiUrl.endsWith('/') ? environment.apiUrl : environment.apiUrl + '/'

  getPaymentStatus(consultationId: string): Observable<PaymentStatus> {
    return this.http.get<PaymentStatus>(`${this.base}payments/${consultationId}`)
  }

  createPaymentIntent(consultationId: string): Observable<PaymentIntentResponse> {
    return this.http.post<PaymentIntentResponse>(`${this.base}payments/intent`, { consultationId })
  }

  static formatAmount(amount: number, currency: string): string {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(amount / 100)
  }
}
